module.exports = __webpack_public_path__ + "static/media/Oranguru_gaussian2.94cba2e5.png";